import { AssignmentPriority, AssignmentResponse, AssignmentStatus } from "@/api";

const priorityOrder: Record<AssignmentPriority, number> = {
  [AssignmentPriority.High]: 3,
  [AssignmentPriority.Normal]: 2,
  [AssignmentPriority.Low]: 1,
};

export function splitAndSort(assignments: AssignmentResponse[]) {
  const open = assignments
    .filter((a) => a.status === AssignmentStatus.Open)
    .sort(
      (a, b) =>
        a.dueDate.getTime() - b.dueDate.getTime() ||
        priorityOrder[b.priority] - priorityOrder[a.priority] ||
        a.createdAt.getTime() - b.createdAt.getTime()
    );

  const completed = assignments
    .filter((a) => a.status === AssignmentStatus.Completed)
    .sort((a, b) => a.statusUpdatedAt.getTime() - b.statusUpdatedAt.getTime());

  return { open, completed };
}
